import React, { Fragment, useEffect, useState } from "react";
import {
  Typography,
  TextField,
  Grid,
  InputLabel,
  Autocomplete,
  Select,
  MenuItem,
  Input,
  Button,
  IconButton,
  Checkbox,
  FormControlLabel,
  Modal,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DeleteIcon from "@mui/icons-material/Delete";

import { makeStyles } from "@mui/styles";

import { useSelector } from "react-redux";

import { CUSTOMER_ALLOWED_WAREHOUSES } from "../../../../config";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const OrderlistProducts = (props) => {
  const {
    categorySettings,
    customer,
    orderList,
    orderListSettings,
    olProductMissing,
    categoryListSettings,
    handleChangeCategorySettings,
    handleChangeCategoryProductAdd,
    onDragEnd,
    onDelete,
    toggleImportingModal,
    products,
    handleChangeProductAuto,
  } = props;

  const classes = useStyles();

  const currentUserStore = useSelector((state) => state.current_user);

  const [productsFiltered, setProductsFiltered] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState({
    olIndex: null,
    catIndex: null,
    prodIndex: null,
  });

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const deleteModalContent = (
    <div className={classes.modal}>
      Are you sure you want to delete this product from the category?
      <br />
      <br />
      <div align="right">
        <Button onClick={() => toggleDeleteModal()}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onDelete(
              deleteInfo.olIndex,
              deleteInfo.catIndex,
              deleteInfo.prodIndex,
            );
            toggleDeleteModal();
          }}
        >
          Confirm
        </Button>
      </div>
    </div>
  );

  useEffect(() => {
    const filterProducts = () => {
      setProductsFiltered(() => {
        const productsData = !currentUserStore?.is_staff
          ? products.filter((item) => {
              if (CUSTOMER_ALLOWED_WAREHOUSES.length === 0) return true;

              if (!item.warehouse?.id) return false;

              return CUSTOMER_ALLOWED_WAREHOUSES.includes(item.warehouse.id);
            })
          : products;

        const productsFilteredArray = productsData
          .filter((item) =>
            categorySettings.include_inactive ? true : item.active,
          )
          .filter((item) =>
            categorySettings.include_nonprimary ? true : item.is_primary,
          );

        return productsFilteredArray;
      });
    };

    if (products.length) {
      filterProducts();
    }
  }, [currentUserStore, products, categorySettings]);

  return (
    <div className={classes.paper}>
      <Modal open={deleteModal} onClose={toggleDeleteModal}>
        {deleteModalContent}
      </Modal>
      <Grid container spacing={2} alignItems="center">
        {currentUserStore?.is_staff === true && (
          <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
            <Button
              variant="contained"
              color="info"
              onClick={() => toggleImportingModal()}
            >
              Import from CSV
            </Button>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            padding: 20,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
            marginBottom: 20,
            marginTop: 16,
          }}
          className="new-product"
        >
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={12}>
              <Typography component="h4" style={{ fontWeight: "bold" }}>
                Add product to category
              </Typography>
            </Grid>
            <Grid item xs={12} sm={true}>
              <InputLabel shrink id="productLabel">
                Products
              </InputLabel>
              <Autocomplete
                fullWidth
                size="small"
                name="product"
                options={productsFiltered}
                getOptionLabel={(option) =>
                  `${option.name} | (${option.upc}) #${
                    option.item_code.item_code || ""
                  }#`
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" variant="standard" />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    {`${option.name} | (${option.upc}) #${
                      option.item_code.item_code || ""
                    }# Stock: ${option.stock_level || 0}`}
                  </li>
                )}
                isOptionEqualToValue={(option, value) =>
                  option.upc === value.upc
                }
                value={categorySettings && categorySettings.product}
                onChange={(e, v) => handleChangeCategorySettings(e, v)}
                onInputChange={(e, v) => handleChangeProductAuto(e, v)}
              />
            </Grid>
            {currentUserStore?.is_staff === true && (
              <>
                <Grid item xs={12} sm={"auto"}>
                  <FormControlLabel
                    value="start"
                    control={
                      <Checkbox
                        name="include_inactive"
                        value={
                          categorySettings && categorySettings.include_inactive
                        }
                        checked={
                          categorySettings && categorySettings.include_inactive
                        }
                        onChange={(e, v) => handleChangeCategorySettings(e, v)}
                        color="primary"
                      />
                    }
                    label="Show Inactive"
                    labelPlacement="end"
                  />
                  <br />
                  <FormControlLabel
                    value="start"
                    control={
                      <Checkbox
                        name="include_nonprimary"
                        value={
                          categorySettings &&
                          categorySettings.include_nonprimary
                        }
                        checked={
                          categorySettings &&
                          categorySettings.include_nonprimary
                        }
                        onChange={(e, v) => handleChangeCategorySettings(e, v)}
                        color="primary"
                      />
                    }
                    label="Show Non Primary"
                    labelPlacement="end"
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}></Grid>
            {!categorySettings?.company_location && (
              <Grid item xs={12} sm={true}>
                <InputLabel shrink id="company_location_label">
                  Customer Location
                </InputLabel>
                <Select
                  fullWidth
                  name="company_location"
                  input={<Input />}
                  value={categorySettings && categorySettings.company_location}
                  onChange={handleChangeCategorySettings}
                >
                  <MenuItem value="">
                    <em>- None -</em>
                  </MenuItem>
                  <MenuItem
                    key={`company_location_${customer.id}`}
                    value={customer.id}
                  >
                    {customer.name}
                  </MenuItem>
                </Select>
              </Grid>
            )}
            {!categorySettings?.orderlist && (
              <Grid item xs={12} sm={true}>
                <InputLabel shrink id="orderlist_label">
                  Order Guide
                </InputLabel>
                <Select
                  fullWidth
                  name="orderlist"
                  input={<Input />}
                  value={categorySettings && categorySettings.orderlist}
                  disabled={
                    categorySettings.company_location === "" ||
                    !orderListSettings.length
                  }
                  onChange={handleChangeCategorySettings}
                >
                  <MenuItem value="">
                    <em>- None -</em>
                  </MenuItem>
                  {orderListSettings.map((item) => (
                    <MenuItem key={`orderlist_${item}`} value={item}>
                      {`Order Guide ${item}`}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            )}
            <Grid item xs={12} sm={true}>
              <InputLabel shrink id="orderlist_label">
                Category
              </InputLabel>
              <Select
                fullWidth
                name="category"
                input={<Input />}
                value={categorySettings && categorySettings.category}
                disabled={
                  categorySettings.orderlist === "" ||
                  !categoryListSettings.length
                }
                onChange={handleChangeCategorySettings}
              >
                <MenuItem value="">
                  <em>- None -</em>
                </MenuItem>
                {categoryListSettings.map((item) => (
                  <MenuItem key={`category_${item}`} value={item}>
                    {`${item}`}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid
              item
              xs={12}
              sm={"auto"}
              style={{ justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleChangeCategoryProductAdd(categorySettings)}
                disabled={
                  !categoryListSettings.includes(categorySettings.category) ||
                  categorySettings.orderlist === "" ||
                  categorySettings.company_location === "" ||
                  categorySettings.product === null
                }
              >
                Add product
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {olProductMissing && (
            <Typography style={{ color: "red", textAlign: "center" }}>
              <b>Warning: </b> There might be some missing Order Guide items.
              You can identify them by the wording:
              <b> undefined (undefined).</b>
            </Typography>
          )}
        </Grid>
        <DragDropContext onDragEnd={onDragEnd}>
          {orderList.map((orderListObj, olIndex) => (
            <Fragment key={`orderlist-${orderListObj.id}`}>
              <Grid item xs={12} sm={12}>
                <Typography
                  component="h4"
                  style={{ fontWeight: "bold", marginBottom: 16 }}
                >
                  {`Products for Categories in Order Guide ${orderListObj.company_location_name}`}
                </Typography>
              </Grid>
              {orderListObj.categories.map((category, catIndex) => (
                <Fragment key={`orderlist-${orderListObj.id}-cat-${catIndex}`}>
                  <Grid item xs={12} sm={12}>
                    <Typography style={{ fontWeight: "bold" }}>
                      {category.category_name}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Droppable
                      droppableId={`orderlist-${orderListObj.id}-cat-${catIndex}`}
                    >
                      {(provided) => (
                        <Grid
                          container
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {category.rows.map((product, prodIndex) => (
                            <Draggable
                              key={`orderlist-${orderListObj.id}-cat-${catIndex}-prod-${prodIndex}-${product.upc}`}
                              draggableId={`orderlist-${orderListObj.id}-cat-${catIndex}-prod-${prodIndex}-${product.upc}`}
                              index={prodIndex}
                            >
                              {(provided) => (
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "#fff",
                                      boxShadow:
                                        "0 8px 24px rgba(0, 0, 0, 0.12)",
                                      transform: "translateY(-2px)",
                                    },
                                  }}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className={
                                    product.active === false ? "iInactive" : ""
                                  }
                                  style={{
                                    ...provided.draggableProps.style,
                                    backgroundColor: "#fff",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    padding: "12px",
                                    marginBottom: "8px",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.06)",
                                    transition: "all 0.3s ease",
                                    opacity: product.active === false ? 0.6 : 1,
                                  }}
                                >
                                  <Grid
                                    container
                                    spacing={0}
                                    alignItems="center"
                                    sx={{ gap: "8px" }}
                                  >
                                    <Grid item xs={"auto"}>
                                      <IconButton aria-label="drag">
                                        <DragIndicatorIcon />
                                      </IconButton>
                                    </Grid>
                                    <Grid item xs={true}>
                                      {`${product.name} (${product.upc})`}
                                    </Grid>
                                    <Grid item xs={"auto"}>
                                      <IconButton
                                        aria-label="delete"
                                        onClick={() => {
                                          setDeleteInfo({
                                            olIndex,
                                            catIndex,
                                            prodIndex,
                                          });
                                          toggleDeleteModal();
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </Grid>
                      )}
                    </Droppable>
                  </Grid>
                </Fragment>
              ))}
            </Fragment>
          ))}
        </DragDropContext>
      </Grid>
    </div>
  );
};

export default OrderlistProducts;
